"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRightInScrollable = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var useNumberState_1 = require("./useNumberState");
function useRightInScrollable() {
    var _a = tslib_1.__read(useNumberState_1.useNumberState(), 2), right = _a[0], setRight = _a[1];
    var _b = tslib_1.__read(react_1.useState(null), 2), content = _b[0], setContent = _b[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    react_1.useEffect(function () {
        if (content) {
            var style = window.getComputedStyle(content, ":before");
            var currentRight = content.offsetWidth - parseFloat(style.width);
            if (currentRight !== right) {
                setRight(currentRight);
            }
        }
    });
    return {
        right: right,
        content: content,
        setContent: setContent,
    };
}
exports.useRightInScrollable = useRightInScrollable;
//# sourceMappingURL=useRightInScrollable.js.map